import { Outlet, useLocation } from 'react-router-dom';
import { ExecutionBadge } from '../components/ExecutionBadge';
import { MetaPanel } from '../components/MetaPanel';
import { Sidebar } from '../components/Sidebar';
import { useOnlineStatus } from '../hooks/useOnlineStatus';
import { TOOL_DEFS } from '../utils/tools';

export function AppLayout() {
  const location = useLocation();
  const isOnline = useOnlineStatus();
  const activeTool = TOOL_DEFS.find((tool) => tool.route === location.pathname);

  return (
    <main className="grid h-full min-h-0 overflow-hidden grid-cols-1 lg:grid-cols-[16rem_1fr] xl:grid-cols-[16rem_1fr_20rem]">
      <Sidebar />
      <section className="min-h-0 overflow-auto p-3 md:p-4">
        {activeTool && (
          <div className="mb-3 flex flex-wrap items-center justify-between gap-2 rounded-md border border-white/10 bg-surface-800/50 px-3 py-2 text-xs text-slate-300">
            <span className="flex items-center gap-2">
              <span className="font-medium text-slate-200">{activeTool.label}</span>
              <ExecutionBadge execution={activeTool.execution} />
            </span>
            {!isOnline && activeTool.execution === 'hybrid' ? (
              <span className="text-amber-200" role="status" aria-live="polite">
                <strong className="font-semibold">Offline:</strong> network lookups are unavailable;
                local processing still works.
              </span>
            ) : activeTool.execution === 'hybrid' ? (
              <span>Local features stay in-browser; lookups use the network.</span>
            ) : null}
          </div>
        )}
        <Outlet />
      </section>
      <MetaPanel />
    </main>
  );
}
